// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","rgpdProvider":"Xbe4F","text":"_7bvke","radioButtonList":"_1S6_E","radioButton":"_2CsOs"};